import Button from "components/shared/Button";
import { FC } from "react";
import { Link, useParams } from "react-router-dom";
import styles from "./SuccessForm.module.sass";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";

interface SuccessFormProps {
	closeAll: () => void;
	close: () => void;
	object: any;
}

export const SuccessForm: FC<SuccessFormProps> = ({ closeAll, close, object }) => {
	const { organizationId } = useParams();

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>Данные сохранены</h4>
			<span className={styles.subtitle}>
				Для дополнения данных по адресам размещения объекта, перейдите в <span> </span>
				<Link
					to={`/categorization/organizations/${organizationId}/steps/2.2/info`}
					state={{ id: object.id, name: object.name }}
					className={styles.link}>
					расширенную информацую об объекте{" "}
				</Link>
			</span>
			<div className={styles.btns}>
				<Button onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED} className={styles.button}>
					Отменить
				</Button>
				<Button type="submit" onClick={closeAll} className={styles.button}>
					Готово
				</Button>
			</div>
		</section>
	);
};
